/**
* 员工管理 商品管理
*/
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>绩效统计</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="搜索：">
        <el-input size="small" v-model="formInline.staffName" placeholder="输入员工姓名"></el-input>
      </el-form-item>
      <el-form-item >
        <el-input size="small" v-model="formInline.cycleName" placeholder="奖励名"></el-input>
      </el-form-item>
      <el-form-item>
        <el-input size="small" v-model="formInline.rewardName" placeholder="周期描述"></el-input>
      </el-form-item>

      <el-form-item>
        <template>
          <div class="block">
            <el-date-picker
              size="small"
              value-format="yyyy-MM"
              v-model="formInline.date"
              type="month"
              placeholder="请选择奖励时间">
            </el-date-picker>
          </div>
        </template>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button size="small" type="primary" icon="el-icon-plus" @click="handleEdit()">添加</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
      <el-table-column align="center" type="selection" width="60">
      </el-table-column>
      <el-table-column sortable prop="cycleName" label="奖励名" width="120">
      </el-table-column>
      <el-table-column sortable prop="rewardName" label="奖励周期" width="120">
      </el-table-column>
      <el-table-column sortable prop="staff.staffName" label="奖励人" width="100">
      </el-table-column>
      <el-table-column sortable prop="standardValue" label="达标值" width="100">
      </el-table-column>
      <el-table-column sortable prop="amount" label="奖励金额" width="100">
      </el-table-column>
      <el-table-column sortable prop="startDate" label="开始时间" width="100">
        <template slot-scope="scope">
          <div>{{formatDate(scope.row.startDate)}}</div>
        </template>
      </el-table-column>
      <el-table-column sortable prop="createTime" label="结束时间" width="100">
        <template slot-scope="scope">
          <div>{{formatDate(scope.row.endDate)}}</div>
        </template>
      </el-table-column>
      <el-table-column align="center" label="操作" min-width="200">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit( scope.row)">编辑</el-button>
          <el-button size="mini" type="danger" @click="deleteStaffReward(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <!-- 编辑界面 -->
    <el-dialog title="修改奖励信息" :visible.sync="editStaffRewardFormVisible" width="45%" @click="closeDialog">
      <el-form label-width="120px" :inline="false" :model="editStaffRewardForm" :rules="rules" ref="editForm">
        <el-row type="flex" justify="start" align="middle">
          <el-col :span="10">
            <el-form-item label="奖励名" prop="mchName">
              <el-input size="small" v-model="editStaffRewardForm.cycleName" disabled auto-complete="off" placeholder="请输入商户名称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="奖励周期" prop="mchAddr">
              <el-input size="small" v-model="editStaffRewardForm.rewardName" disabled auto-complete="off" placeholder="请输入商户地址"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex" justify="start" align="middle">
          <el-col :span="10">
            <el-form-item label="奖励人" prop="userName">
              <el-input size="small" v-model="editStaffRewardForm.staff.staffName" disabled auto-complete="off" placeholder="请输入联系人"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="奖励金额" prop="userPhone">
              <el-input size="small" v-model="editStaffRewardForm.amount"  auto-complete="off" placeholder="请输入联系人手机号"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="submitForm()">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  mchSave,
  deptDelete,
  changeMchStatus,
  staffRewardPage,
  updateStaffReward,
  delStaffReward
} from '../../api/userMG'
import Pagination from '../../components/Pagination'
export default {
  data() {
    return {
      nshow: true, //switch开启
      fshow: false, //switch关闭
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      editStaffRewardFormVisible: false,
      editStaffRewardForm:{
        rewardId: null,
        cycleName:"",
        rewardName:"",
        staff:{
          staffName: ""
        },
        amount:null
      },
      title: '添加',
      formInline: {
        current: 1,
        size: 10,
        staffId: null,
        staffName:'',
        rewardName: '',
        cycleName:'',
        date: null,
        token: localStorage.getItem('logintoken')
      },
      editForm: {
        mchId: null,
        mchName: '',
        mchAddr: '',
        userName:'',
        userPhone:'',
        loginName:'',
        loginPassWord:'',
        mchStatus:null,
        token: localStorage.getItem('logintoken')
      },
      editStatusForm:{
        mchId: '',
        mchStatus: '',
        token: localStorage.getItem('logintoken')
      },
      // rules表单验证
      rules: {
        mchName: [{ required: true, message: '请输入商户名名称', trigger: 'blur' }],
        mchAddr: [{ required: true, message: '请输入商户地址代码', trigger: 'blur' }]
      },
      // 删除部门
      seletedata: {
        ids: '',
        token: localStorage.getItem('logintoken')
      },
      userparm: [], //搜索权限
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      },
      mchStatusEnum:[
        { key: '启用', value: 1},
        { key: '禁用', value: 0},
      ],
    }
  },
  // 注册组件
  components: {
    Pagination
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.getdata(this.formInline)
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    // 获取公司列表

    getdata: function (parameter) {
      this.loading=true
      /***
       * 调用接口，注释上面模拟数据 取消下面注释
       */
      staffRewardPage(parameter)
        .then(res => {
          this.loading = false
          if (res.code !== '200') {
            this.$message({
              type: 'info',
              message: res.message
            })
          } else {
            this.listData = res.data.content
            // 分页赋值
            this.pageparm.currentPage = res.data.pages
            this.pageparm.total = res.data.total
            this.loading=false
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('菜单加载失败，请稍后再试！')
        })
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.current = parm.currentPage
      this.formInline.size = parm.pageSize
      this.getdata(this.formInline)
    },
    // 搜索事件
    search() {
      this.getdata(this.formInline)
    },
    //显示编辑界面
    handleEdit: function(row) {
      this.editStaffRewardFormVisible = true
      this.editStaffRewardForm.cycleName = row.cycleName
      this.editStaffRewardForm.rewardName = row.rewardName
      this.editStaffRewardForm.staff.staffName = row.staff.staffName
      this.editStaffRewardForm.amount = row.amount
      this.editStaffRewardForm.rewardId=row.rewardId
    },
    // 编辑、增加页面保存方法
    submitForm() {
      this.loading=true
      updateStaffReward(this.editStaffRewardForm).then(res => {
            this.editStaffRewardFormVisible = false
            this.loading = false
            if (res.code==='200') {
              this.getdata(this.formInline)
              this.$message({
                type: 'success',
                message: '绩效奖励修改成功！'
              })
            } else {
              this.$message({
                type: 'info',
                message: res.message
              })
              this.loading=false
            }
          }).catch(err => {
            this.editFormVisible = false
            this.loading = false
            this.$message.error('绩效奖励修改失败，请稍后再试！')
          })
    },
    // 删除绩效奖励
    deleteStaffReward(row) {
      this.$confirm('确定要删除吗?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading=true
        delStaffReward(row.rewardId).then(res => {
              if (res.code==='200') {
                this.$message({
                  type: 'success',
                  message: '绩效奖励已删除!'
                })
                this.getdata(this.formInline)
                this.loading=false
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
                this.loading=false
              }
            }).catch(err => {
              this.loading = false
              this.$message.error('绩效奖励删除失败，请稍后再试！')
            })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    formatDate(timestamp){
      if(timestamp===null){
        return '';
      }
      const dateObj = new Date(timestamp);
      const year = dateObj.getFullYear();
      const month = ('0' + (dateObj.getMonth() + 1)).slice(-2);
      const day = ('0' + dateObj.getDate()).slice(-2);
      return `${year}-${month}-${day}`;
    },
    // 关闭编辑、增加弹出框
    closeDialog() {
      this.editStaffRewardFormVisible = false
    },
    mchStatusChange(index, row){
      this.editStatusForm.mchId=row.mchId
      this.editStatusForm.mchStatus=row.mchStatus;
      this.loading=true
      changeMchStatus(this.editStatusForm).then(res => {
        if (res.code==='200') {
          this.$message({
            type: 'success',
            message: '状态已修改！'
          })
          this.getdata(this.formInline)
          this.loading=false
        } else {
          this.$message({
            type: 'info',
            message: res.message
          })
          this.loading=false
        }
      }).catch(err => {
        this.loading = false
        this.$message.error('修改状态失败，请稍后再试！')
        this.getdata(this.formInline)
      })
    }
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
</style>





// WEBPACK FOOTER //
// src/views/staff/StaffReward.vue